module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [_c('h3', [_vm._v("Snow Levels")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Temperature (degrees Fahrenheit)")])]), _vm._v(" "), _c('legend-chart', {
    attrs: {
      "colors": _vm.colors,
      "dataValues": _vm.dataValues,
      "field": _vm.legend_temp
    }
  }), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "text-center"
  }, [_vm._v("Snow/Water Equivalence (inches)")]), _vm._v(" "), _c('circle-legend-chart', {
    attrs: {
      "dataValues": _vm.dataValues,
      "field": _vm.legend_snow,
      "whichType": _vm.whichType
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "id": "snow_graph"
    }
  }, [_c('svg', {
    attrs: {
      "id": "snow",
      "height": _vm.graph_height,
      "width": _vm.graph_width
    }
  }, [_c('g', {
    staticClass: "axis x",
    attrs: {
      "transform": _vm.graph_translate
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "axis y",
    attrs: {
      "transform": _vm.graph_translate_left
    }
  }), _vm._v(" "), _vm._l((_vm.snow_data), function(d, index) {
    return [_c('circle', {
      attrs: {
        "id": _vm.whichType + d.state + index,
        "cx": _vm.xYearScale(d.date),
        "cy": _vm.elevationScale(d.elev),
        "r": _vm.circleSize(d.snow_mean),
        "fill": _vm.color(d.temp_mean),
        "transform": _vm.graph_translate
      },
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    })]
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-palmer"
  }, [_c('p', [_vm._v("Snow is vital to the environmental health of the western United States. Unlike rainfall, it doesn't\n        come as one burst that's here and then quickly gone. Instead, it tends to accrue over the winter and slowly\n        melt as the temperatures rise in the spring. The melt typically continues into the early summer, providing\n        a steady, consistent level of water in mountain watersheds. This is particularly important for a\n        state like California, which receives almost no summer rainfall.")]), _vm._v(" "), _c('p', [_vm._v("Snow comes in a variety of forms. It can be light and airy, almost dry, or it can heavy and dense. For example,\n        light, fluffy snow that measures four feet deep might actually have the\n        same volume of water as heavier, denser snow that is two feet deep.To account\n        for this variation a measure called\n        "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "http://www.nrcs.usda.gov/wps/portal/nrcs/detail/or/snow/?cid=nrcs142p2_046155",
      "target": "_blank"
    }
  }, [_vm._v("snow water equivalence")]), _vm._v(" is used to normalize the amount of liquid water\n        in a given level of snow. The graph below uses "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://www.wcc.nrcs.usda.gov/snow"
    }
  }, [_vm._v("SNOTEL")]), _vm._v("\n        data; a series of automated weather stations distributed across the west to\n        measure things such as snow levels and temperature. Notice how temperature and snow levels change with elevation.\n        Compare the average snow/water levels by year and elevation. The general trend is towards drier\n        conditions, but wet years are interspersed with drier years.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bed5f724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SnowChart.vue
// module id = 383
// module chunks = 1